// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { SpaceSmall, SpaceMedium, SpaceLarge } from './Spacer.styles';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

function Spacer(props) {
  const { children, size } = props;

  return (
    <>
      {size === 'sm' && <SpaceSmall>{children}</SpaceSmall>}
      {size === 'md' && <SpaceMedium>{children}</SpaceMedium>}
      {size === 'lg' && <SpaceLarge>{children}</SpaceLarge>}
      {!size && children}
    </>
  );
}

Spacer.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']).isRequired,
  children: ReactChildrenPropType
};

Spacer.defaultProps = {
  children: undefined
};

export default Spacer;
